import { render, staticRenderFns } from "./AssignaturesSelector2.vue?vue&type=template&id=01713003&scoped=true"
import script from "./AssignaturesSelector2.vue?vue&type=script&lang=js"
export * from "./AssignaturesSelector2.vue?vue&type=script&lang=js"
import style0 from "./AssignaturesSelector2.vue?vue&type=style&index=0&id=01713003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01713003",
  null
  
)

export default component.exports